import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE = "Calculatrice Diam\u00e8tre du Carr\u00e9";
const DESCRIPTION =
  "Utilisez la calculatrice du diam\u00e8tre du carr\u00e9 pour calculer facilement et pr\u00e9cis\u00e9ment la diagonale d'un carr\u00e9. Entrez la longueur du c\u00f4t\u00e9 pour obtenir le diam\u00e8tre en utilisant la formule appropri\u00e9e.";
const KEYWORDS =
  "calculatrice diam\u00e8tre du carr\u00e9, calcul diam\u00e8tre carr\u00e9, g\u00e9om\u00e9trie, math\u00e9matiques, longueur du c\u00f4t\u00e9, diagonale, racine carr\u00e9e";
const OG_URL = "https://do-calculate.com/calculator/fr/square-diameter-calculator/";
function SquareDiameterCalculator() {
  const [sideLength, setSideLength] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [steps, setSteps] = useState([]);

  const handleCalculate = () => {
    try {
      if (!sideLength) {
        setError("Veuillez entrer la longueur du c\u00f4t\u00e9.");
        return;
      }
      const side = parseFloat(sideLength);
      if (isNaN(side) || side <= 0) {
        setError("Veuillez entrer une valeur positive valide.");
        return;
      }
      const sqrt2 = Math.sqrt(2);
      const diameter = sqrt2 * side;
      const calculationSteps = [
        `Racine carr\u00e9e de 2 = ${sqrt2.toFixed(2)}`,
        `Longueur du c\u00f4t\u00e9 = ${sideLength} cm`,
        `Diam\u00e8tre = ${sqrt2.toFixed(2)} \u00d7 ${sideLength} = ${diameter.toFixed(2)} cm`,
      ];
      setResult(diameter.toFixed(2));
      setSteps(calculationSteps);
      setError("");
    } catch (err) {
      setError("Une erreur s'est produite lors du calcul. Veuillez r\u00e9essayer.");
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Vous avez besoin de calculer le diam\u00e8tre d'un carr\u00e9 rapidement et avec pr\u00e9cision ? Notre calculatrice intelligente est la solution id\u00e9ale ! En utilisant la formule math\u00e9matique correcte, notre calculatrice calcule le diam\u00e8tre du carr\u00e9 en fonction de la longueur de son c\u00f4t\u00e9.
                </p>
                <p>
                  Il vous suffit d'entrer la longueur du c\u00f4t\u00e9 du carr\u00e9 dans le champ pr\u00e9vu, et vous obtiendrez le r\u00e9sultat imm\u00e9diatement. Pas besoin de vous soucier des calculs complexes, notre calculatrice s'occupe de tout \u00e0 votre place.
                </p>
                <p>
                  <strong>Diam\u00e8tre du carr\u00e9 = Racine carr\u00e9e de 2 \u00d7 longueur du c\u00f4t\u00e9</strong>
                </p>
                <ul>
                  <li>Entrez la longueur du c\u00f4t\u00e9 pour calculer le diam\u00e8tre du carr\u00e9.</li>
                </ul>
                <p>
                  Cette calculatrice a \u00e9t\u00e9 d\u00e9velopp\u00e9e pour simplifier le calcul du diam\u00e8tre du carr\u00e9 et garantir la pr\u00e9cision des r\u00e9sultats.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <hr />
                  <div className="form-group">
                    <label className="form-label" htmlFor="sideLength">
                      Entrez la longueur du c\u00f4t\u00e9 (cm)
                    </label>
                    <input
                      id="sideLength"
                      type="number"
                      value={sideLength}
                      onChange={(e) => setSideLength(e.target.value)}
                      placeholder="Longueur du c\u00f4t\u00e9"
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={handleCalculate}
                  >
                    Calculer
                  </button>
                </div>
                <br />
                {error !== "" && (
                  <p className="p-3 mb-2 bg-warning text-black">
                    Erreur : {error}
                  </p>
                )}
                {result && (
                  <div className="p-3 mb-2 bg-success">
                    <h4 className="text-white">R\u00e9sultat :</h4>
                    <p className="text-white">{result} cm</p>
                    <div className="p-3 mb-2 bg-info text-black" style={{ width: "100%" }}>
                      <h4>\u00c9tapes :</h4>
                      <ul>
                        {steps.map((step, index) => (
                          <li key={index}>{step}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
                <hr />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Qu'est-ce que le diam\u00e8tre du carr\u00e9 ?</div>
              <div className="info-section-body">
                <div>
                  <u><h2 style={{ fontSize: "16px" }}>Concept du diam\u00e8tre du carr\u00e9</h2></u>
                  <p>
                    Le diam\u00e8tre du carr\u00e9 est la distance entre deux angles oppos\u00e9s \u00e0 l'int\u00e9rieur du carr\u00e9. Le calcul du diam\u00e8tre du carr\u00e9 est utilis\u00e9 dans de nombreuses applications g\u00e9om\u00e9triques et math\u00e9matiques.
                  </p>
                  <ul>
                    <li><strong>Diam\u00e8tre du carr\u00e9 = Racine carr\u00e9e de 2 \u00d7 longueur du c\u00f4t\u00e9</strong></li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    Exemple : si la longueur du c\u00f4t\u00e9 est 5 cm, le diam\u00e8tre du carr\u00e9 est : \u221a2 \u00d7 5 \u2248 7,07 cm
                  </div>
                </div>
                <hr />
                <div>
                  <u><h2 style={{ fontSize: "16px" }}>Comment calculer le diam\u00e8tre du carr\u00e9</h2></u>
                  <p>Pour calculer le diam\u00e8tre du carr\u00e9, suivez les \u00e9tapes suivantes :</p>
                  <ul>
                    <li>Entrez la longueur du c\u00f4t\u00e9 dans la formule appropri\u00e9e.</li>
                    <li>Multipliez la racine carr\u00e9e de 2 par la longueur du c\u00f4t\u00e9 pour obtenir le diam\u00e8tre.</li>
                    <li>V\u00e9rifiez que la valeur saisie est correcte et pr\u00e9cise.</li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    Exemple : si la longueur du c\u00f4t\u00e9 est 7 cm, le diam\u00e8tre du carr\u00e9 est : \u221a2 \u00d7 7 \u2248 9,90 cm
                  </div>
                </div>
                <hr />
                <div>
                  <u><h2 style={{ fontSize: "16px" }}>Questions fr\u00e9quentes</h2></u>
                  <p>R\u00e9ponses \u00e0 quelques questions courantes sur le diam\u00e8tre du carr\u00e9 et son calcul.</p>
                  <div className="p-3 mb-2 bg-info text-black">
                    Question : Pourquoi utilise-t-on la racine carr\u00e9e de 2 pour calculer le diam\u00e8tre du carr\u00e9 ?
                    <br />
                    R\u00e9ponse : La racine carr\u00e9e de 2 refl\u00e8te la relation entre la longueur du c\u00f4t\u00e9 et le diam\u00e8tre du carr\u00e9, car le diam\u00e8tre relie deux angles oppos\u00e9s selon le th\u00e9or\u00e8me de Pythagore : d\u00b2 = c\u00f4t\u00e9\u00b2 + c\u00f4t\u00e9\u00b2.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SquareDiameterCalculator;
